// Get saved data from localStorage
export function getItem(key: string): string | null {
    return window.localStorage.getItem(key)
}

// Remove saved data from localStorage
export function removeItem(key: string): void {
    window.localStorage.removeItem(key)
}

// Save data to localStorage
// Do not store sensitive data in localStorage
export const setItem = (key: string, value: string): void => {
    window.localStorage.setItem(key, value)
}

// Clear localStorage
export const clear = (): void => {
    window.localStorage.clear()
}

export default {
    getItem,
    removeItem,
    setItem,
    clear,
}
